// Strip a redundant leading "MRN-" / "MRN " prefix on the VALUE so a
// UI label "MRN:" doesn't duplicate it (some legacy clients carry
// values like "MRN-000001"). Display-only — storage is untouched.
export const formatMrn = (mrn) => {
  if (!mrn) return '';
  return String(mrn).replace(/^\s*MRN[-\s_]*/i, '');
};

// True when the query matches the MRN with OR without the "MRN-" prefix
// on either side (e.g. query "000123" finds "MRN-000123" and vice versa).
export const mrnMatches = (mrn, query) => {
  if (!mrn || !query) return false;
  const m = String(mrn).toLowerCase();
  const q = String(query).toLowerCase().trim();
  if (!q) return false;
  if (m.includes(q)) return true;
  const qs = formatMrn(q).toLowerCase();
  return !!qs && formatMrn(m).toLowerCase().includes(qs);
};

export default formatMrn;
